module.exports = __webpack_public_path__ + "img/notWinning.e9d01ceb.png";